import { fg } from '@atlassian/jira-feature-gating';
import { matchUrlParams } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/index.tsx';
import type { MatcherLocation } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/url-matchers/types.tsx';
import type { JiraSpaRoute } from '@atlassian/react-resource-router';

export const backlogSelected = (currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
	matchUrlParams(['rapidView'])(currentLocation, itemLocation) &&
	(currentLocation.query.view ?? '').includes('planning');

export const boardSelected = (currentLocation: MatcherLocation, itemLocation: MatcherLocation) =>
	matchUrlParams(['rapidView'])(currentLocation, itemLocation) &&
	!currentLocation.query.useStoredSettings &&
	!currentLocation.query.view;

export const calculateStack = (route: JiraSpaRoute | null) =>
	route?.name === 'rapidboard-report' ||
	route?.name === 'rapidboard-user-report' ||
	(['rapidboard-user-reports-overview', 'software-reports-velocity-user-board'].includes(
		route?.name ?? '',
	) &&
		fg('reports-overview-page-migration'))
		? ['reports']
		: [];
